import { gql } from '@apollo/client'

export const GET_USERS = gql`
  query getUsers($searchQuery: String, $limit: Int, $offset: Int) {
    Users(searchQuery: $searchQuery, limit: $limit, offset: $offset) {
      rows {
        id
        name
        username
        first_name
        last_name
        email
        phone
        id_role
        RoleOfUser {
          role_name
        }
        is_disabled
        disabled_at
      }
      count
    }
  }
`

export const GET_USER_BY_ID = gql`
  query GetUserById($getUserByIdId: Int!) {
    GetUserById(id: $getUserByIdId) {
      id
      username
      name
      first_name
      last_name
      email
      phone
      id_role
      jurisdiction_id
      is_coordinator
      array_sub_jurisdiction {
        value
        label
      }
      charge
      JobPositionOfUser {
        name
      }
      provider_id
      id_user_register
      avatarUrl
      array_group_category {
        value
        label
      }
      array_group_category_sub {
        value
        label
      }
      array_processes_category {
        value
        label
      }
      array_processes_category_sub {
        value
        label
      }
    }
  }
`

export const EXPORT_USERS = gql`
  mutation GetAllUsersExport {
    getAllUsersExport {
      id
      name
      email
      phone
      id_role
      id_user_register
    }
  }
`

export const GET_USER = gql`
  mutation getOneUser($userId: Int!) {
    getUser(userID: $userId) {
      name
      phone
      address
    }
  }
`

export const GET_USER_BY_NAME_PHONE_ADDRESS = gql`
  mutation GetUserByNamePhoneAddress(
    $name: String
    $phone: String
    $address: String
    $type_user: String
  ) {
    getUserByNamePhoneAddress(
      name: $name
      phone: $phone
      address: $address
      type_user: $type_user
    ) {
      id
      name
      phone
      address
    }
  }
`

export const GET_ALL_USER_PERMISSIONS = gql`
  mutation getAllUserPermissions($userID: Int!) {
    getAllUserPermissions(userID: $userID) {
      id
      id_module
      ReportsPowerBIModelOfUserModules {
        sub_module_id
        power_bi_id
        pathname_module
        front_label
        icon
      }
      module_info {
        name
        relative_link
        icon
        front_label
      }
      submodule_info {
        name
        relative_link
        icon
        front_label
      }
      id_submodule
      access_retrieve
      access_read
      access_edit
      access_delete
      access_export
      access_import
    }
  }
`

export const GET_USERS_BY_CHARGE = gql`
  query GetUsersByCharge($edit: Boolean, $truck_id: Int) {
    getUsersByCharge(edit: $edit, truck_id: $truck_id) {
      id
      name
      first_name
      last_name
      email
      phone
      # id
      # type_user
      # name
      # first_name
      # last_name
    }
  }
`

export const GET_USER_DATA_BY_ID = gql`
  query GetUserDataById($getUserDataByIdId: Int!) {
    GetUserDataById(id: $getUserDataByIdId) {
      id_role
      JobPositionOfUser {
        name
      }
    }
  }
`

export const REGISTER_USER = gql`
  mutation RegisterUser($input: userRegisterInput!, $avatarFile: Upload!) {
    registerUser(input: $input, avatarFile: $avatarFile) {
      id
      email
    }
  }
`

export const REGISTER_USE_FROM_LOGIN = gql`
  mutation RegisterUserFromLogin($input: userRegisterInputFromLogin!) {
    registerUserFromLogin(input: $input) {
      id
      email
      id_role
    }
  }
`

export const UPDATE_USER = gql`
  mutation UpdateUser(
    $userId: Int!
    $input: userRegisterInput!
    $avatarFile: Upload
  ) {
    updateUser(userID: $userId, input: $input, avatarFile: $avatarFile)
  }
`

export const DELETE_USER = gql`
  mutation DeleteUserMutation($id: Int!, $userId: Int!) {
    deleteUser(id: $id, userId: $userId)
  }
`

export const SEND_PASSWORD_TO_EMAIL = gql`
  mutation SendPasswordToEmail($email: String!) {
    sendPasswordToEmail(email: $email)
  }
`

export const UPDATE_PASSWORD = gql`
  mutation RecoveryUserPassword($inputRecovery: passwordRecoveryInput!) {
    recoveryUserPassword(inputRecovery: $inputRecovery)
  }
`

export const UPDATE_USER_PASSWORD = gql`
  mutation PasswordUpdate(
    $idUser: Int!
    $currentPassword: String!
    $password: String!
  ) {
    passwordUpdate(
      id_user: $idUser
      currentPassword: $currentPassword
      password: $password
    )
  }
`

export const CHECK_TOKEN_RECOVERY = gql`
  mutation checkTokenRecovery($token: String!) {
    checkTokenRecovery(token: $token)
  }
`

export const EXPORTS_USERS = gql`
  mutation ExportUsers {
    exportUsers {
      data {
        id
        email
        name
        phone
        date
      }
      headers {
        key
        label
      }
    }
  }
`

export const VALID_ALREADY_EXIST_USER = gql`
  mutation ValidAlreadyExistUserEmail(
    $input: validAlreadyExistUserEmailInput!
  ) {
    validAlreadyExistUserEmail(input: $input)
  }
`

export const UPDATE_ROL_USER_PERMISSIONS = gql`
  mutation UpdateRolUserAndPermissions($id_user: Int!, $id_role: Int!) {
    updateRolUserAndPermissions(id_user: $id_user, id_role: $id_role)
  }
`
export const GET_USERS_BY_CATEGORY_GROUP_ID = gql`
  query GetUsersByCategory(
    $subCategoryId: Int
    $userType: String
    $parentCategoryId: Int
  ) {
    getUsersByCategory(
      sub_category_id: $subCategoryId
      user_type: $userType
      parent_category_id: $parentCategoryId
    ) {
      id
      name
      first_name
      last_name
    }
  }
`
export const UPDATE_STATUS_DISABLED_USER = gql`
  mutation UpdateUserDisabledStatus($userId: Int!, $disableValue: Boolean) {
    updateUserDisabledStatus(user_id: $userId, disableValue: $disableValue)
  }
`
